import { toPercent } from '@utils/Format'

export const getClassRent = ({
  estatisticas_classe,
  classe,
  bench_selected,
  mapper_benchmarks,
  with_bench = true,
  benchmarks = [],
}) => {
  if (!estatisticas_classe.Todos) {
    return '-'
  }
  if (!estatisticas_classe[classe]) {
    return '-'
  }
  const benchStats = estatisticas_classe[classe].benchmarks_statistics
  if (
    bench_selected &&
    (!benchStats ||
      !benchStats[bench_selected.id_benchmark || bench_selected.id])
  ) {
    return '-'
  }
  const mapBenchmarks = benchmarks.reduce((acc, benchmark) => {
    acc[benchmark.id] = benchmark
    return acc
  }, {})
  const cdiBenchmark = benchmarks.find((benchmark) => benchmark.nome === 'CDI')
  const bench = bench_selected || mapper_benchmarks[classe] || cdiBenchmark
  const benchKey = bench.id_benchmark || bench.id || bench
  const bench_rent =
    benchStats && benchStats[benchKey] ? benchStats[benchKey].rent_inicio : 0
  const rent = estatisticas_classe[classe].inicio
  const benchmark = mapBenchmarks[benchKey]
  if (benchmark) {
    bench.benchmark = benchmark.nome || bench.benchmark
  }
  if (bench.benchmark === 'CDI') {
    if (!bench_rent) {
      return with_bench ? '- CDI' : '-'
    }
    return toPercent((rent / bench_rent) * 100) + (with_bench ? ' CDI' : '')
  } else {
    const rent_final = rent - bench_rent
    if (with_bench) {
      const nome = bench.benchmark || 'Benchmark'
      let text = ''
      if (nome.includes(' + ')) {
        text += `(${nome})`
      } else {
        text += `${nome}`
      }
      if (rent_final >= 0) {
        text += ' + ' + toPercent(rent_final * 100)
      } else {
        text += ' ' + toPercent(rent_final * 100)
      }
      return text || '-'
    } else {
      return toPercent(rent_final * 100)
    }
  }
}
